import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Group } from './../group/group.interface';
import { ServiceHelperService } from '@asamco/utils';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';

import { GroupService } from '../group/group.service';
import { UsergroupService } from '../usergroup/usergroup.service';
import { User } from './user.interface';

/**
 *Service for userdata
 *
 * @export
 */
@Injectable({
	providedIn: 'root',
	deps: [ServiceHelperService, UsergroupService, GroupService],
})
export class UserService {
	/** Database actions */
	private dbActions = this.serviceHelper.createHelper<User>('user');

	/** Gets all users */
	getAll = this.dbActions.getAll;

	/** Get user by id */
	get = this.dbActions.get;

	/** Save user */
	save = this.dbActions.save;

	/** Delete user */
	delete = this.dbActions.delete;

	/**
	 *Creates an instance of UserService.
	 * @param serviceHelper
	 * @param usergroupService
	 * @param groupService
	 */
	constructor(
		private serviceHelper: ServiceHelperService,
		private usergroupService: UsergroupService,
		private groupService: GroupService,
		private http: HttpClient
	) {}

	/**
	 * Gets the groups for a specific user
	 * @param userId The id of the user
	 */
	getUserGroups(userId: number): Observable<Group[]> {
		const groupIds$ = this.usergroupService.getByUserId(userId).pipe(map(data => data.map(row => row.groupId)));
		const groups$ = this.groupService.getAll();

		return zip(groupIds$, groups$).pipe(map(([groupIds, groups]) => groupIds.map(id => groups.filter(group => group.id === id)[0])));
	}

	setActive(userId: number, isActive: boolean): Observable<User> {
		return this.http.post<User>(`user/setactive/${userId}/${isActive}`, {});
	}
}
